import { useState, useEffect } from "react";
import "./table.css";
import "./policies.css";
import { Divider } from "@material-ui/core";
import { Box, Button, Stack } from "@mui/material";
import PoliciesInfoPopup from "./PoliciesInfoPopup";

import axios from "axios";
import { IP } from "../../../baseUrlAndConfig";
import { ValidateAuth } from "../../../AuthToken";
import { getCookie } from "../../../Cookies";
import { useNavigate } from "react-router";
import HrTopNavbar from "../../Sidebar/HrTopNavbar";
import InfrastructureInfoPopup from "./InfrastructureInfoPopup";
// import { PoliciesArr } from "./infuraData";
export default function Policies({
  overallgender,
  setOverallgender,
  overAllFlag,
  companyId,
}) {
  const [PoliciesArr, setPoliciesArr] = useState([]);

  const [policiesState, setPolociesState] = useState({});

  const [refflag, setrefflag] = useState(true);

  const navigate = useNavigate();
  const goToHome = () => navigate("/");
  useEffect(() => {
    // ValidateAuth();
    // let newobj = JSON.parse(getCookie("roles"));
    // if (!newobj.HRDI?.includes(getCookie("ROLE"))) {
    //   goToHome();
    //   return <></>;
    // }
  }, []);

  const functionCallOnSelect = (data) => {
    //let name = data.heading.replaceAll(" ", "");
    // setPoliciesArr((prev) => {
    //   return prev.filter((ele, index) => {
    //     if (index == data.index) {
    //       ele.isAgree = data.ans;
    //     }
    //     return ele;
    //   });
    // });

    //console.log(PoliciesArr);
    let arr = [];
    for (let i = 0; i < PoliciesArr.length; i++) {
      if (i == data.index) {
        let obj = {};
        obj.heading = PoliciesArr[i].heading;
        obj.description = PoliciesArr[i].description;
        obj.isAgree = data.ans;
        obj.type = PoliciesArr[i]?.type;
        console.log(obj);
        arr.push(obj);
      } else {
        arr.push(PoliciesArr[i]);
      }
    }
    let configrecrut = {
      method: "patch",

      url: `${IP}/policies?companyId=${companyId}`,

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: JSON.stringify(arr),
    };

    axios(configrecrut)
      .then((res) => {
        fetchdata();
      })
      .catch((ee) => {
        //   console.log("t");
      });

    //console.log(PoliciesArr);
    //setPolociesState((prev) => ({ ...prev, [name]: data.ans }));
  };

  useEffect(() => {
    setrefflag(!refflag);
    // setgenderbyRegionStates(ex);
  }, [PoliciesArr]);

  const fetchdata = () => {
    let configrecrut = {
      method: "get",

      url: `${IP}/policies?companyId=${companyId}`,

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregionf",
    };

    axios(configrecrut).then((res) => {
      setPoliciesArr([]);
      /// console.log(PoliciesArr);
      // console.log(res.data);
      setPoliciesArr(res.data);
    });
  };
  useEffect(() => {
    fetchdata();
    // setPolociesState(
    //   overallgender.policiesState ? overallgender.policiesState : {}
    // );

    // setgenderbyRegionStates(ex);
  }, [overAllFlag]);

  // console.log(overallgender);
  return (
    <Box>
      <Box
        sx={{
          position: "sticky",
          top: "0",
          backgroundColor: "#F3F1FF",
          zIndex: "2",
          pt: "24px",
        }}
      >
        <HrTopNavbar title={"Policies"}>
          {/* <Box sx={{ display: "flex", gap: "10px" }}>
          <Box sx={{ display: "flex", gap: "10px", fontSize: "14px" }}>
            {" "}
            <Box
              sx={{
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                bgcolor: "#E1F566",

                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {" "}
              01
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {" "}
              Course completed{" "}
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: "10px", fontSize: "14px" }}>
            {" "}
            <Box
              sx={{
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                bgcolor: "#E1F566",

                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {" "}
              64
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {" "}
              Course completed{" "}
            </Box>
          </Box>
        </Box> */}
        </HrTopNavbar>
      </Box>

      <Stack
        spacing={4}
        className="tablebgColorForHr"
        style={{
          marginTop: "24px",
          backgroundColor: "#F3F1FF",
          marginLeft: "25px",
          marginBottom: "100px",
        }}
      >
        {PoliciesArr?.map((el, index) => (
          <Box
            sx={{
              display: "grid",

              gridTemplateColumns: "6fr 1fr",

              // justifyContent: "space-between",
              // alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 18fr 2fr",
              }}
            >
              <Box
                sx={{
                  color: "#000",
                  backgroundColor: "#F3F1FF",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                }}
              >
                {index + 1}.
              </Box>
              <Box sx={{ display: "flex", width: "98%" }}> {el.heading} </Box>
              <Box>
                {" "}
                <InfrastructureInfoPopup data={el?.description} />
              </Box>
            </Box>

            <Box style={{ display: "flex", gap: "20px" }}>
              <Button
                sx={{
                  width: "64px",
                  height: "40px",
                  borderRadius: "12px",
                  backgroundColor: el.isAgree ? "#E1F566" : "#BCBCBC",
                }}
                onClick={() => {
                  functionCallOnSelect({
                    heading: el.heading,
                    ans: true,
                    index,
                  });
                }}
              >
                Yes
              </Button>

              <Button
                sx={{
                  width: "64px",
                  height: "40px",
                  borderRadius: "12px",
                  backgroundColor: el.isAgree === false ? "#E1F566" : "#BCBCBC",
                }}
                onClick={() => {
                  functionCallOnSelect({
                    heading: el.heading,
                    ans: false,
                    index,
                  });
                }}
              >
                No
              </Button>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
